import { ContractOnboardingStatus } from '@/bpc/mf-fields/enm/ContractOnboardingStatus';
const { PENDING, UNDERWRITING_INITIATED, CONTRACT_SIGNED, ONBOARDING_COMPLETED, SUSPENDED, TERMINATED, } = ContractOnboardingStatus;
export const QUICK_POLLING_INTERVAL = 3 * 1000;
export const SLOW_POLLING_INTERVAL = 10 * 1000;
export const REDIRECT_TIMEOUT_IN_MILLISECONDS = 5 * 1000;
export const getPollingInterval = (status) => [PENDING, UNDERWRITING_INITIATED].includes(status)
    ? QUICK_POLLING_INTERVAL
    : SLOW_POLLING_INTERVAL;
export const startPolling = (status) => ![SUSPENDED, TERMINATED, ONBOARDING_COMPLETED].includes(status);
export const stopPolling = (status) => [SUSPENDED, TERMINATED, ONBOARDING_COMPLETED].includes(status);
// Statuses for which we display identical status information
export const STATUS_OVERRIDES = {
    [CONTRACT_SIGNED]: UNDERWRITING_INITIATED,
    [TERMINATED]: SUSPENDED,
};
